<template>
  <div class="notification-teaser"
       :class="{ unread: !notification.is_read }">
    <div class="notification-text pr-4 pb-1">
      {{ notification.text }}
      <div v-if="notification.task">
        <a class="pointer text-primary"
           @click="showTask">
          {{ $t('task') }} {{ notification.task.title }}
        </a>
      </div>
      <div v-if="notification.notification_additional_info">
        <a class="pointer text-primary"
           v-if="notification.notification_additional_info.lead_id"
           @click="showLead">
          {{ $t('lead') }} #{{ notification.notification_additional_info.lead_id }}
        </a>
        <a class="pointer text-primary"
           v-if="notification.notification_additional_info.patient_canban_id"
           @click="showPatientCanban">
          {{ $t('funnel') }}
        </a>
        <a class="pointer text-primary"
           v-if="notification.notification_additional_info.patient"
           @click="toPatientFeed">
          {{ $t('live_feed') }}: {{ notification.notification_additional_info.patient.full_name }}
        </a>
      </div>
    </div>
    <div class="text-right text-muted small">
      {{ formatDateTime(notification.sent_at_timezoned) }}
    </div>
    <a class="position-absolute notification-delete pointer"
       @click="deleteNotification">
      <TrashSvg class="svg-light mr-0"/>
    </a>
  </div>
</template>

<script setup>
import TrashSvg from '@/assets/svg-vue/general/trash_tr.svg'
import { EloquentService } from "@/services/api/eloquent.api.service"
import {formatDateTime} from "@/extensions/filters/filters"
import {appendFormdata} from "@/extensions/prototypes/prototypes"
import {useRouter} from "vue-router"

const emit = defineEmits(['onDelete', 'onShowTask'])

const router = useRouter()

const props = defineProps({
  notification: Object
})

const deleteNotification = () => {
  let formData = new FormData()
  formData = appendFormdata(formData, { show_in_header: 0 })
  EloquentService.update('notification', props.notification.id, formData).then(() => {
    emit('onDelete')
  })
}

const showTask = () => {
  emit('onShowTask', props.notification.task_id)
}

const showLead = () => {
  router.push(`/crm/lead/${props.notification.notification_additional_info.lead_id}`)
}

const showPatientCanban = () => {
  router.push(`/crm/funnel_patients/${props.notification.notification_additional_info.patient_canban_id}`)
}

const toPatientFeed = () => {
  router.push(`/patients/${props.notification.notification_additional_info.patient.id}/comments`)
}
</script>

<style scoped lang="scss">
.notification-teaser {
  padding-bottom: 5px;
  position: relative;
  &.unread {
    font-weight: bold;
  }
  .notification-text {
    white-space: break-spaces;
  }
  .notification-delete {
    right: 0;
    display: none;
    top: 0;
  }
  &:hover {
    .notification-delete {
      display: block;
      opacity: 0.5;
      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
